/* PDP Leidwell-style test 2026-10-06 (unpublished copy only). Desktop gallery arrows on the main image, Leidwell look.
   They only click the theme's own thumbnail buttons, so the theme's gallery logic stays in charge. No copy, no cart code. */
(function () {
  if (!document.querySelector('.lw-print')) return;
  function init() {
    var gal = document.querySelector('.product:has(.lw-print) media-gallery') || document.querySelector('media-gallery');
    if (!gal || gal.querySelector('.lw-garrow')) return;
    var stage = gal.querySelector('slider-component.product-media-slider');
    var thumbs = function () { return Array.prototype.slice.call(gal.querySelectorAll('.thumbnail-list__item button.thumbnail')); };
    if (!stage || thumbs().length < 2) return;
    function mk(dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lw-garrow lw-garrow--' + dir;
      b.setAttribute('aria-label', dir === 'prev' ? 'Previous image' : 'Next image');
      b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + (dir === 'prev' ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '"/></svg>';
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var t = thumbs();
        var i = t.findIndex(function (x) { return x.getAttribute('aria-current') === 'true'; });
        if (i < 0) i = 0;
        var n = (i + (dir === 'prev' ? -1 : 1) + t.length) % t.length;
        t[n].click();
      });
      return b;
    }
    stage.appendChild(mk('prev'));
    stage.appendChild(mk('next'));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Fix round 6 (Renar 2026-10-07): "you can't open these images at all as a big screen". The template's zoom settings are "none",
   so the theme's product-image-zoom.js does not wire the gallery to its lightbox. This keeps it that way even if a zoom setting
   is switched back in the editor: on the print PDP the lightbox's open() does nothing. Swipe, arrows, thumbnails and dots are
   separate code and are not touched. */
(function () {
  if (!document.querySelector('.lw-print')) return;
  function shut() {
    Array.prototype.forEach.call(document.querySelectorAll('product-lightbox'), function (lb) {
      if (lb.dataset.lwNoOpen) return;
      lb.dataset.lwNoOpen = '1';
      lb.open = function () {};
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', shut); else shut();
})();

/* Fix round 7 (Renar 2026-10-07): the phone thumbnail strip under the picture (the theme's own, restyled in pdp-leidwell.css).
   It keeps the current thumbnail in view, centred in the strip as on northvaleguides.com, and sets the 10% edge fade on the side
   that has more. Follow-up (Renar: "pictures below move 1 sec later"): the theme marks the current thumbnail only ~0.6 s after a
   slide change (its media-gallery waits 500 ms after the slider's change event). So on phones this block marks it at once: on an
   arrow press (the target slide is known before the picture moves) and while the picture list scrolls under a finger (the slide
   nearest the left edge). A thumbnail tap locks the mark on the tapped one until the picture arrives, so the strip does not step
   through the slides in between. The theme's own later mark lands on the same thumbnail. Centring is instant.
   Phones only (max-width 749px); desktop and tablet are not touched. */
(function () {
  if (!document.querySelector('.lw-print')) return;
  var mq = window.matchMedia('(max-width: 749px)');
  function wire() {
    var gal = document.querySelector('.product:has(.lw-print) media-gallery') || document.querySelector('media-gallery');
    if (!gal) return;
    var ul = gal.querySelector('.thumbnail-slider .thumbnail-list');
    var list = gal.querySelector('.product-media-slider .product__media-list');
    if (!ul || !list || ul.dataset.lwStrip) return;
    ul.dataset.lwStrip = '1';
    function fade() {
      var max = ul.scrollWidth - ul.clientWidth;
      ul.classList.toggle('lw-fade-l', mq.matches && ul.scrollLeft > 1);
      ul.classList.toggle('lw-fade-r', mq.matches && ul.scrollLeft < max - 1);
    }
    function centre() {
      if (!mq.matches) return;
      var b = ul.querySelector('.thumbnail[aria-current="true"]');
      if (!b) return;
      var li = b.closest('li') || b, ur = ul.getBoundingClientRect(), lr = li.getBoundingClientRect();
      ul.scrollTo({ left: Math.max(0, ul.scrollLeft + (lr.left - ur.left) - (ur.width - lr.width) / 2), behavior: 'instant' });
    }
    function thumbs() { return Array.prototype.filter.call(ul.querySelectorAll('.thumbnail-list__item'), function (li) { return !li.classList.contains('hidden'); }); }
    function items() { return Array.prototype.filter.call(list.querySelectorAll(':scope > .product__media-item'), function (li) { return !li.classList.contains('hidden'); }); }
    function nearest() {
      var its = items(), l = list.getBoundingClientRect().left, best = 0, d = 1e9;
      its.forEach(function (it, i) { var x = Math.abs(it.getBoundingClientRect().left - l); if (x < d) { d = x; best = i; } });
      return { i: best, d: d };
    }
    function mark(i) {
      var t = thumbs();
      if (!t[i]) return;
      var b = t[i].querySelector('button.thumbnail');
      if (!b || b.getAttribute('aria-current') === 'true') return;
      t.forEach(function (li) { var x = li.querySelector('button.thumbnail'); if (x && x !== b) x.removeAttribute('aria-current'); });
      b.setAttribute('aria-current', 'true');
    }
    var lock = -1, lockUntil = 0;
    function lockTo(i) { lock = i; lockUntil = Date.now() + 1200; }
    gal.addEventListener('click', function (e) {
      if (!mq.matches) return;
      var arrow = e.target.closest('.product-media-slider .slider-button--prev, .product-media-slider .slider-button--next');
      if (arrow && !arrow.disabled) {
        var n = items().length, i = nearest().i + (arrow.classList.contains('slider-button--next') ? 1 : -1);
        i = Math.max(0, Math.min(n - 1, i));
        lockTo(i); mark(i);
        return;
      }
      var tb = e.target.closest('.thumbnail-slider .thumbnail-list__item');
      if (tb) lockTo(thumbs().indexOf(tb));
    }, true);
    var raf = 0;
    list.addEventListener('scroll', function () {
      if (!mq.matches || raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var n = nearest();
        if (lock >= 0 && Date.now() < lockUntil) { if (n.i === lock && n.d < 2) lock = -1; return; }
        lock = -1;
        mark(n.i);
      });
    }, { passive: true });
    ul.addEventListener('scroll', fade, { passive: true });
    window.addEventListener('resize', function () { fade(); centre(); });
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) if (ms[i].target.getAttribute('aria-current') === 'true') { centre(); break; }
    }).observe(ul, { subtree: true, attributes: true, attributeFilter: ['aria-current'] });
    fade();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wire); else wire();
})();

/* Fix round 8 (Renar 2026-10-07, "this whole box should be clickable to select or unselect this"): a click or tap anywhere on an
   extras card toggles that extra exactly as its control does. It calls the card's own button.ssw-toggle .click(), so the v13-print
   block's handler (on #ssw-offers, untouched) flips the state, aria-checked and the session opt-out once. A click ON the control
   (or its 44 px hit area), on a link or on a form control is left alone, so nothing toggles twice. A drag that selects text does
   not toggle. Keyboard and screen readers keep the button (role=switch). */
(function () {
  if (!document.querySelector('.lw-print')) return;
  function wire() {
    var box = document.getElementById('ssw-offers');
    if (!box || box.dataset.lwCardClick) return;
    box.dataset.lwCardClick = '1';
    box.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-toggle], a[href], button, input, select, textarea, label, summary')) return;
      var card = t.closest('.ssw-offer');
      if (!card || !box.contains(card)) return;
      var sel = window.getSelection ? window.getSelection() : null;
      if (sel && !sel.isCollapsed && sel.anchorNode && card.contains(sel.anchorNode)) return;
      var b = card.querySelector('button.ssw-toggle[data-toggle]');
      if (b) b.click();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wire); else wire();
})();
